import React, { useState, useEffect } from 'react';

const useToast = () => {
    const [show, setShow] = useState(false);
    const [cb, setCb] = useState();
    const [toastContent, setToastContent] = useState('');
    let timer = null;

    const setShowWithCb = (cb) => {
        setShow(true);
        setCb(cb);
    };

    useEffect(() => {
        if (show) {
            timer = setTimeout(() => {
                setShow(false);
                if (cb) {
                    cb();
                    setCb(null);
                }
            }, 3000);
        }

        return () => {
            clearTimeout(timer);
        };
    }, [show]);

    return { show, setShow, setToastContent, toastContent, setShowWithCb };
};

export default useToast;
